
const nationalityEnum = {
 INDIAN:"Indian",
 NRI:"NRI",
 FOREIGN_NATIONAL:"Foreign National",
 FNIO_PIO:"FNIO/PIO",
 OTHERS:"Other"

}

export default nationalityEnum;
